import { render, staticRenderFns } from "./VestingPercentRightPanelInputs.vue?vue&type=template&id=6487f2da&"
import script from "./VestingPercentRightPanelInputs.vue?vue&type=script&lang=js&"
export * from "./VestingPercentRightPanelInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports